import { Component, input, effect, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
    public readonly photoUrl = input<string|undefined>(undefined);
    public readonly name = input<string|undefined>(undefined);

    public showInitials = false;
    public initials?: string;

    constructor() {
        effect(() => {  
            this.createInititals();
        });
        effect(() => {
            this.showInitials = !this.photoUrl();
        });
    }

    private createInititals(): void {
        let initials = "";
        if(this.name()){
            for (let i = 0; i < this.name()!.length; i++) {
                if (this.name()!.charAt(i) === ' ') continue;
                if (this.name()!.charAt(i) === this.name()!.charAt(i).toUpperCase()) {
                    initials += this.name()!.charAt(i);
                    if (initials.length == 2) break;
                }
            }
        }
        this.initials = initials;
    }
}